import React, { useState } from 'react';
import { Table, EmptyListPlaceholder, CSVViewer, Notification, STATUS_TYPES, TableLoader, USER_PERMISSIONS, PRODUCT_PERMISSIONS } from 'dyl-components';
import { Table as SemanticTable } from 'semantic-ui-react';
import { ImportTableHeader } from './Header';
import { ImportTableRow } from './Row';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import * as XLSX from 'xlsx';

import leadIngestionActions from 'actions/lead_ingestion';
import RestrictedView from '../../../shared/RestrictedView';

export const ImportTable = () => {
    const dispatch = useDispatch();
    const [idOfFileBeingPreviewed, setIdOfFileBeingPreviewed] = useState(null);

    const importDataReducer = useSelector(state => state.import_data);
    const isReadingImportCSV = useSelector(state => state.import_data.isReadingImportCSV);

    const { import_data, import_count, isReadingImports, csv } = importDataReducer;

    const onPreview = (file_id) => {
        setIdOfFileBeingPreviewed(file_id);
        dispatch(leadIngestionActions.readCSVFile(encodeURIComponent(file_id))).catch(error => {
            console.log(error)
            Notification.alert('Failed to retrieve CSV file', STATUS_TYPES.ERROR, true);
        });
    }

    const onClosePreview = () => {
        setIdOfFileBeingPreviewed(null);
    }

    const buildWorkbookFromCSV = (csvString) => {
        const data = csvString
            .trim()
            .split("\n")
            .map((line) => line.split(","));
        const sheet = XLSX.utils.aoa_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, sheet, "Sheet1");
        return workbook;
    };


    const fileBeingPreviewed = import_data.find(item => item.file_id === idOfFileBeingPreviewed)

    return (
        <React.Fragment>
            <Table striped={false} unstackable>
                <SemanticTable.Header className='Table__header--primary'>
                    <ImportTableHeader />
                </SemanticTable.Header>
                <Table.Body className='ImportTable'>
                    {isReadingImports ? <TableLoader isLoading colspan={7} /> : import_data.map((data, index) => (
                        <ImportTableRow key={index} importItem={data} onPreview={onPreview} />
                    ))}
                </Table.Body>
            </Table>
            {!isReadingImports && import_count === 0 && (
                <EmptyListPlaceholder
                    name="Import"
                    subtitle={
                        <span>
                            Add an Import by clicking on the{" "}
                            <RestrictedView
                                type="link"
                                userPermission={USER_PERMISSIONS.IMPORT_DATA_ADD}
                                productPermission={PRODUCT_PERMISSIONS.RECORDS}
                            >
                                <Link to="/settings/import-data/setup">
                                    + New Import
                                </Link>
                            </RestrictedView>
                            {" "}button on the top-right corner.
                        </span>
                    }
                />
            )}
            <CSVViewer
                title={fileBeingPreviewed?.file_name}
                csv={csv ? buildWorkbookFromCSV(csv) : null}
                isPreviewing={idOfFileBeingPreviewed !== null}
                isReadingCSV={isReadingImportCSV}
                onClosePreview={onClosePreview}
            />
        </React.Fragment>

    );
}




